<template>
  <div>
    <div class="vtl">
      <div v-if="model.name !== 'root'">
        <div class="vtl-border vtl-up" />
        <div :id="model.id" style="position: relative" :class="treeNodeClass">
          <span
            v-if="model.children && model.children.length > 0"
            class="vtl-caret vtl-is-small"
            style="left: -15px"
          >
            <i
              class="vtl-icon"
              :class="caretClass"
              @click.prevent.stop="toggle"
            />
          </span>

          <div style="display: inline-flex; width: 100%">
            <div class="vtl-node-content" style="width: calc(100% - 30px)">
              <b>{{ model.evaluation_administrator_node_nomenclature }}</b>
              {{ model.evaluation_administrator_node_requirementName }}
            </div>
            <div style="width: 30px; text-align: right">
              <b-form-checkbox
                v-model="improvementRequired"
                name="check-button"
              />
            </div>
          </div>
        </div>

        <div
          v-if="model.children && model.children.length > 0 && expanded"
          class="vtl-border vtl-bottom"
          @drop="dropAfter"
          @dragenter="dragEnterBottom"
          @dragover="dragOverBottom"
          @dragleave="dragLeaveBottom"
        />
      </div>
      <div
        v-show="model.name === 'root' || expanded"
        v-if="isFolder"
        :class="{ 'vtl-tree-margin': model.name !== 'root' }"
      >
        <evaluation-improvements-tree-list
          v-for="model in model.children"
          :key="model.id"
          :default-expanded="defaultExpanded"
          :model="model"
          :selected-nodes="selectedNodes"
        />
      </div>
      <b-modal
        id="modalInfo"
        v-model="showModal"
        modal-class="modalInfo"
        :title="'Delete '"
      >
        {{ $t("label_evaluation_delete_message") }}
        <b> {{ model.evaluation_administrator_node_requirementName }}</b>
        <div slot="modal-footer" class="w-100" style="text-align: right">
          <b-btn variant="primary" @click="hideModal()">
            {{ $t("label_evaluation_cancel_button") }}
          </b-btn>
          <b-btn variant="primary" @click="delNode()">
            {{ $t("label_evaluation_create_button") }}
          </b-btn>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script >
import {
  addHandler,
  removeHandler,
} from "../../../../utils/vue-tree-list/tools";
let compInOperation = null;
export default {
  name: "EvaluationImprovementsTreeList",
  props: {
    account: {
      type: Object,
      default: () => {},
    },
    model: {
      type: Object,
    },
    selectedNodes: {
      type: Array,
      default: () => [],
    },
    defaultLeafNodeName: {
      type: String,
      default: "New leaf node",
    },
    defaultTreeNodeName: {
      type: String,
      default: "New tree node",
    },
    defaultExpanded: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      isHover: false,
      editable: false,
      isDragEnterUp: false,
      isDragEnterBottom: false,
      isDragEnterNode: false,
      expanded: this.defaultExpanded,
      showModal: false,
      improvementRequired: false,
      labels: {
        0: "label_evaluation_not achieved",
        50: "label_evaluation_partially achieved",
        75: "label_evaluation_close to be achieved",
        100: "label_evaluation_achieved",
      },
    };
  },
  computed: {
    itemIconClass() {
      return this.model.isLeaf ? "vtl-icon-file" : "vtl-icon-folder";
    },
    caretClass() {
      return this.expanded ? "vtl-icon-caret-down" : "vtl-icon-caret-right";
    },

    isFolder() {
      return this.model.children && this.model.children.length;
    },

    treeNodeClass() {
      const {
        model: { dragDisabled, disabled },
      } = this;

      return {
        "vtl-tree-node": true,
        "vtl-drag-disabled": dragDisabled,
        "vtl-disabled": disabled,
        "hover-activated":
          !this.model.children || this.model.children.length === 0,
      };
    },
  },
  watch: {
    improvementRequired: function () {
      this.model.improvementRequired = this.improvementRequired;
      this.checkImprovement();
    },
  },
  created() {
    this.model.improvementRequired = false;
    let selectedNodesIds = this.selectedNodes.map((node) => node.id);
    if (selectedNodesIds.includes(this.model.id)) {
      this.improvementRequired = true;
      this.checkImprovement();
      this.$forceUpdate();
    }
  },
  mounted() {
    const vm = this;
    addHandler(window, "keyup", function (e) {
      // click enter
      if (e.keyCode === 13 && vm.editable) {
        vm.editable = false;
      }
    });
  },
  beforeDestroy() {
    removeHandler(window, "keyup");
  },
  methods: {
    checkImprovement() {
      var node = this.getRootNode();
      node.$emit("dataChanged");
    },
    fillProgress() {
      // eslint-disable-next-line camelcase
      if (this.model.children && this.model.children.length > 0) {
        var total = 0;
        this.model.children.map((child) => {
          if (!isNaN(child.evaluation_status)) {
            if (child.children && child.children.length > 0) {
              total = total + parseFloat(child.evaluation_status);
            } else {
              total =
                total +
                (child.evaluation_status *
                  child.evaluation_administrator_node_percentualWeight) /
                  100;
            }
          }
          if (
            total >= this.model.evaluation_administrator_node_percentualWeight
          ) {
            // eslint-disable-next-line camelcase
            this.model.evaluation_status =
              this.model.evaluation_administrator_node_percentualWeight;
          } else {
            // eslint-disable-next-line camelcase
            this.model.evaluation_status = total;
          }
        });

        var totalP = 0;
        this.model.children.map((s) => {
          if (s.children && s.children.length > 0) {
            if (s.evaluation_progress === s.children.length) {
              totalP++;
            }
          } else {
            if (!isNaN(s.evaluation_status)) {
              totalP++;
            }
          }
        });
        // eslint-disable-next-line camelcase
        this.model.evaluation_progress = totalP;
      }
      this.$forceUpdate();
      if (this.$parent.fillProgress) {
        this.$parent.fillProgress();
        this.$parent.$forceUpdate();
      }
    },
    showModalF() {
      this.showModal = true;
    },
    hideModal() {
      this.showModal = false;
    },
    updateName(e) {
      var oldName = this.model.name;
      this.model.changeName(e.target.value);
      var node = this.getRootNode();
      node.$emit("change-name", {
        id: this.model.id,
        oldName: oldName,
        newName: e.target.value,
      });
    },

    delNode() {
      // var node = this.getRootNode()
      this.model.remove();
      // node.$emit('delete-node', this.model)
    },

    setEditable() {
      /*        this.editable = true
        this.$nextTick(() => {
          const $input = this.$refs.nodeInput
          $input.focus()
          $input.setSelectionRange(0, $input.value.length)
        })*/
      var root = this.getRootNode();
      root.$emit("modify-node", this.model, true);
    },

    setUnEditable() {
      this.editable = false;
    },

    toggle() {
      if (this.isFolder) {
        this.expanded = !this.expanded;
      }
    },

    mouseOver() {
      if (this.model.disabled) {
        return;
      }
      this.isHover = true;
    },

    mouseOut() {
      this.isHover = false;
    },

    click() {
      /*        if (!this.model.children || this.model.children.length === 0) {
          var node = this.getRootNodeAndPath()
          node.node.$emit('updatePath', node.path)
          node.node.$emit('click', this.model)
        }*/
    },

    addChild() {
      /*        const name = isLeaf ? this.defaultLeafNodeName : this.defaultTreeNodeName
        this.expanded = true
        var node = new TreeNode({ name, isLeaf })
        this.model.addChildren(node, true)*/
      var root = this.getRootNode();
      this.expanded = true;
      root.$emit("add-node", this.model, false);
    },

    dragStart(e) {
      if (!(this.model.dragDisabled || this.model.disabled)) {
        compInOperation = this;
        // for firefox
        e.dataTransfer.setData("data", "data");
        e.dataTransfer.effectAllowed = "move";
        return true;
      }
      return false;
    },
    dragEnd() {
      compInOperation = null;
    },
    dragOver(e) {
      e.preventDefault();
      return true;
    },
    dragEnter() {
      if (!compInOperation) {
        return;
      }
      if (this.model.isLeaf) {
        return;
      }
      this.isDragEnterNode = true;
    },
    dragLeave() {
      this.isDragEnterNode = false;
    },
    drop() {
      if (!compInOperation) {
        return;
      }
      const oldParent = compInOperation.model.parent;
      compInOperation.model.moveInto(this.model);
      this.isDragEnterNode = false;
      var node = this.getRootNode();
      node.$emit("drop", {
        target: this.model,
        node: compInOperation.model,
        src: oldParent,
      });
    },

    dragEnterUp() {
      if (!compInOperation) {
        return;
      }
      this.isDragEnterUp = true;
    },
    dragOverUp(e) {
      e.preventDefault();
      return true;
    },
    dragLeaveUp() {
      if (!compInOperation) {
        return;
      }
      this.isDragEnterUp = false;
    },
    dropBefore() {
      if (!compInOperation) {
        return;
      }
      const oldParent = compInOperation.model.parent;
      compInOperation.model.insertBefore(this.model);
      this.isDragEnterUp = false;
      var node = this.getRootNode();
      node.$emit("drop-before", {
        target: this.model,
        node: compInOperation.model,
        src: oldParent,
      });
    },

    dragEnterBottom() {
      if (!compInOperation) {
        return;
      }
      this.isDragEnterBottom = true;
    },
    dragOverBottom(e) {
      e.preventDefault();
      return true;
    },
    dragLeaveBottom() {
      if (!compInOperation) {
        return;
      }
      this.isDragEnterBottom = false;
    },
    dropAfter() {
      if (!compInOperation) {
        return;
      }
      const oldParent = compInOperation.model.parent;
      compInOperation.model.insertAfter(this.model);
      this.isDragEnterBottom = false;
      var node = this.getRootNode();
      node.$emit("drop-after", {
        target: this.model,
        node: compInOperation.model,
        src: oldParent,
      });
    },
    getRootNode() {
      var node = this.$parent;
      while (node._props.model.name !== "root") {
        node = node.$parent;
      }
      return node;
    },
    getRootNodeAndPath() {
      var node = this.$parent;
      var path = [];
      while (node._props.model.name !== "root") {
        path.push({
          name: node._props.model.evaluation_administrator_node_requirementName,
          nom: node._props.model.evaluation_administrator_node_nomenclature,
        });
        node = node.$parent;
      }
      return { node, path };
    },
  },
};
</script>
<style lang="scss" scoped>
h4 {
  font-size: 1.3rem;
  text-transform: uppercase;
}
@font-face {
  font-family: "icomoon";
  src: url("../../../../utils/vue-tree-list/fonts/icomoon.eot");
  src: url("../../../../utils/vue-tree-list/fonts/icomoon.eot")
      format("embedded-opentype"),
    url("../../../../utils/vue-tree-list/fonts/icomoon.ttf") format("truetype"),
    url("../../../../utils/vue-tree-list/fonts/icomoon.woff") format("woff"),
    url("../../../../utils/vue-tree-list/fonts/icomoon.svg") format("svg");
  font-weight: normal;
  font-style: normal;
}

.vtl-icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  &.vtl-menu-icon {
    margin-right: 4px;
    &:hover {
      color: inherit;
    }
  }
  &:hover {
    color: blue;
  }
}

.vtl-icon-file:before {
  content: "\e906";
}
.vtl-icon-folder:before {
  content: "\e907";
}
.vtl-icon-caret-down:before {
  content: "\e901";
}
.vtl-icon-caret-right:before {
  content: "\e900";
}
.vtl-icon-edit:before {
  content: "\e902";
}
.vtl-icon-folder-plus-e:before {
  content: "\e903";
}
.vtl-icon-plus:before {
  content: "\e904";
}
.vtl-icon-trash:before {
  content: "\e905";
}

.vtl-border {
  height: 5px;
  &.vtl-up {
    margin-top: -5px;
    background-color: transparent;
  }
  &.vtl-bottom {
    background-color: transparent;
  }
  &.vtl-active {
    border-bottom: 3px dashed blue;
    /*background-color: blue;*/
  }
}
.hover-activated:hover {
  background-color: #f0f0f0;
}
.vtl-tree-node {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  .vtl-input {
    border: none;
    max-width: 150px;
    border-bottom: 1px solid blue;
  }

  &.vtl-active {
    outline: 2px dashed pink;
  }
  .vtl-caret {
    position: absolute;
  }
  .vtl-operation {
    margin-left: 2rem;
    letter-spacing: 1px;
  }
}

.vtl-item {
  cursor: pointer;
}
.vtl-tree-margin {
  margin-left: 2em;
}
.break {
  flex-basis: 100%;
  height: 0;
}

.options {
  font-size: 12px;
  font-style: italic;
  .edit {
    color: #0c3a9b;
  }
}
.vtl-node-content {
  text-align: left;
}
</style>
